import { DialogsService, LongWorkService } from "approot/global/providers/uikit.dialogs";
import { NsModalButton } from "approot/global/ui-components/nsModal";
import { LoginDataService } from "./services/login.data.service";
import { PasswordRecoveryRepository, PasswordRecoveryRequest, PasswordRecoveryResponse, PswRecoveryType, RecoveryAnswerVerificationRequest, RecoveryAnswerVerificationResponse } from "./services/password.recovery.service";

class PasswordRecoveryController {
	public header: string;

	public enableSms: boolean;
	public productName: string;
	public ready: boolean;

	public recoveryType: PswRecoveryType = PswRecoveryType.Email;
	public recoveryValue: string;
	public form: ng.IFormController;

	/*@ngInject*/
	constructor(
		private $dialogs: DialogsService,
		private $longWork: LongWorkService,
		private loginDataService: LoginDataService,
		private passwordRecoveryRepository: PasswordRecoveryRepository,
		private $uibModal: ng.ui.bootstrap.IModalService,
		private $window: ng.IWindowService,
		public language: any
	) {
		this.loginDataService.load().then(() => {
			this.onReady();
		});
	}

	private onReady() {
		let viewData = this.loginDataService.loginData.viewData;

		this.enableSms = viewData.enableSms;
		this.productName = viewData.productName;
		this.ready = true;
	}

	goBack() {
		this.$window.history.back();
	}

	apply() {
		
		let passwordRecoveryRequest: PasswordRecoveryRequest = {
			recoveryType: null,
			recoveryValue: this.recoveryValue
		};

		this.$longWork.show();

		this.passwordRecoveryRepository.validate(passwordRecoveryRequest)
			.then((response) => {
				passwordRecoveryRequest.recoveryType = response;
				return this.passwordRecoveryRepository.getRecoveryResponse(passwordRecoveryRequest);
			})
			.then((response: PasswordRecoveryResponse) => {
				this.$longWork.close();

				let question = response.question;

				return this.getRecoveryAnswerDialog(question);
			})
			.then((answer: string) => {
				let recoveryAnswerVerificationRequest: RecoveryAnswerVerificationRequest = {
					answer: answer,
					recoveryType: this.recoveryType,
					recoveryValue: this.recoveryValue
				};

				this.$longWork.show();
				return this.passwordRecoveryRepository.getRecoveryVerificationResponse(recoveryAnswerVerificationRequest);
			})
			.then((response: RecoveryAnswerVerificationResponse) => {
				this.$longWork.close();
				this.$dialogs.message(response.message);
			}, () => {
				return;
			})	
			.finally(() => {
				this.$longWork.close();
			});
	}

	getRecoveryAnswerDialog(question: string): Promise<any> {
		const modalInstance = this.$uibModal.open({
			controller: class {
				public question: string;
				public answer: string;

				public header: string;
				public buttons: NsModalButton[];

				/*@ngInject*/
				constructor(
					private $dialogs: DialogsService,
					private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
					private language: any
				) {
					this.question = question;
					this.header = this.language.Generic.Messages.kPasswordRecovery;

					const okBtn = {
						title: this.language.Generic.Common.kOk,
						action: () => this.ok(),
						icon: "glyphicon glyphicon-ok-sign"
					};
					const cancelBtn: NsModalButton = {
						title: this.language.Generic.Buttons.kCancel,
						action: () => this.cancel(),
						icon: "glyphicon glyphicon-ban-circle"
					};
					this.buttons = [ okBtn, cancelBtn ];
				}

				ok() {
					if (!this.answer) {
						this.$dialogs.message(this.language.Generic.Login.AnswerCanNotBeEmpty);
						return;
					}

					this.$uibModalInstance.close(this.answer);
				}

				cancel() {
					this.$uibModalInstance.dismiss();
				}

				close() {
					this.$uibModalInstance.dismiss();
				}
			},
			controllerAs: "$ctrl",
			template: `
				<ns-modal controller="$ctrl" header="{{$ctrl.header}}" buttons="$ctrl.buttons">
					<div class="form-horizontal form-xs">
						<div class="form-group">
							<label class="control-label col-md-4 col-lg-3 col-sm-4">
								{{$ctrl.question}}
							</label>
							<div class="col-md-8 col-lg-9 col-sm-8">
								<input type="text" class="form-control" FilterWhiteSpace" size="50" maxlength="50" ng-model="$ctrl.answer">
							</div>
						</div>
					</div>
				</ns-modal>`
		});

		return new Promise((resolve, reject) => {
			modalInstance.result.then((data) => resolve(data), (data) => reject(data));
		});
	}
}

export const PasswordRecoveryComponent = {
	templateUrl: "/static/dist/app/login/password.recovery.component.html",
	controllerAs: "$ctrl",
	controller: PasswordRecoveryController
}